import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import Login from '../pages/login-page/login'
import Home from '../pages/home-page/home'
import FaqPage from '../pages/faq-page/faq-page'
import Profile from '../pages/profile-page/profile'
import { PrivateRoute } from './private-route'
import ReportPage from '../pages/report-page/report-page'

const AppRoutes = () => (
  <Router>
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route path="/" element={<PrivateRoute />}>
        <Route path="" element={<Home />} />
        <Route path="faq" element={<FaqPage />} />
        <Route path="profile" element={<Profile />} />
        <Route path="report" element={<ReportPage />} />
      </Route>
    </Routes>
  </Router>
)

export default AppRoutes
